import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/CustomButtons/Button.jsx';
import Storage from 'services/StorageService';
import config from 'config';
import buildAvatarPath from 'utils/buildAvatarPath';
import { firebase } from 'firebase/fbConfig';
import Loader from 'components/Loader';

const FileUpload = ({ uid, onSuccess, onError, currentPic, currentAvatar }) => {
  let callable;

  const [file, setFile] = useState(null);
  const [avatar, setAvatar] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState(currentPic);

  const onSelect = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (!config.picAllowedExt.includes(fileExtension)) {
      onError(
        `Invalid file: only ${config.picAllowedExt.join(
          ', '
        )} files are allowed`
      );
      return;
    }
    reader.onloadend = () => {
      setFile(file);
      setAvatar(`${uid}_${new Date().getTime()}.${fileExtension}`);
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = () => {
    if (uploading) return;
    setUploading(true);
    Storage.uploadToStorage({
      data: file,
      onError,
      onSuccess: onPicUploaded,
      destination: `${config.avatarStorageFolder}/${avatar}`,
    });
  };

  const onPicUploaded = async () => {
    try {
      callable = callable || firebase.functions().httpsCallable('squareImage');
      const { type } = file;
      const name = avatar;
      const storageFolder = config.avatarStorageFolder;
      const squared = await callable({ name, type, storageFolder });
      if (!squared) {
        throw new Error('The image could not be resized. Please try again.');
      }
      const avatarPath = buildAvatarPath(avatar);
      await onSuccess(avatar);
      setImagePreview(avatarPath);
      setUploading(false);
      setFile(null);
    } catch (error) {
      setFile(null);
      setUploading(false);
      setImagePreview(currentPic);
      console.log(error);
      onError(
        'An error ocurred during the uploading of the file (file too large?). Please try again later'
      );
    } finally {
      if (currentAvatar) {
        // Delete previous avatar but don't display any error if it fails
        Storage.removeFile(`${config.avatarStorageFolder}/${currentAvatar}`);
      }
    }
  };

  return (
    <div
      style={{ backgroundColor: 'rgb(43, 79, 92)' }}
      className='picture-container'
    >
      <div className='picture'>
        <img src={imagePreview} className='picture-src' alt='Your avatarr' />
        <input type='file' onChange={onSelect} />
      </div>
      {file ? (
        <Button
          style={{
            padding: uploading ? '4px 25px' : '12px 30px',
            margin: '-100px 0px 0px 0px',
            boxShadow:
              '0 2px 2px 0 rgba(156, 39, 176, 0), 0 3px 1px -2px rgba(156, 39, 176, 0)',
          }}
          color='primary'
          onClick={handleSubmit}
        >
          {uploading ? <Loader /> : 'UPDATE'}
        </Button>
      ) : (
        <h6 className='description'>Choose Picture</h6>
      )}
    </div>
  );
};

FileUpload.propTypes = {
  onSuccess: () => null,
};

FileUpload.propTypes = {
  uid: PropTypes.string.isRequired,
  currentPic: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default FileUpload;
